import { useEffect, useState } from "react";
import { API_KEY_WEATHER } from "../constants";
import styles from "./DashBoard.module.css";
import DailyForecastChart from "../components/DailyForecastChart";
import HourlyForecastChart from "../components/HourlyForecastChart";
import LocationInfoDisplay from "../components/LocationInfoDisplay";
import Map from "../components/map/Map";
import Navigation from "../components/Navigation";
import WeatherInfoDisplay from "../components/WeatherInfoDisplay";
function DashBoard({
  tempColor,
  setTempColor,
  position,
  getPosition,
  setPosition,
}) {
  const [weatherData, setWeatherData] = useState({});
  const [hourly, setHourly] = useState([]);
  const [daily, setDaily] = useState([]);
  useEffect(
    function () {
      async function fetchData() {
        if (position?.lat === undefined || position?.lng === undefined) return;
        const res = await fetch(
          `https://api.openweathermap.org/data/3.0/onecall?lat=${
            position.lat
          }&lon=${
            position.lng
          }&exclude=${""}&appid=${API_KEY_WEATHER}&units=metric`
        );
        const data = await res.json();
        setWeatherData(data.current);
        setTempColor(data.current.temp);
        setHourly(data.hourly);
        setDaily(data.daily);
      }
      fetchData();
    },
    [position, setTempColor]
  );
  const { dt, pressure, temp, visibility, humidity, clouds } = weatherData;
  return (
    <>
      <Navigation tempColor={tempColor}></Navigation>
      <div className={styles["dashboard-container"]}>
        <div className={styles["forecast-charts-container"]}>
          <HourlyForecastChart
            tempColor={tempColor}
            hourly={hourly}
          ></HourlyForecastChart>
          <DailyForecastChart
            tempColor={tempColor}
            daily={daily}
          ></DailyForecastChart>
        </div>
        <div className={styles["map-display-container"]}>
          <Map
            tempColor={tempColor}
            getPosition={getPosition}
            setPosition={setPosition}
            lat={position?.lat}
            lng={position?.lng}
          ></Map>

          <LocationInfoDisplay
            tempColor={tempColor}
            lat={position?.lat}
            lng={position?.lng}
          ></LocationInfoDisplay>
          <WeatherInfoDisplay
            tempColor={tempColor}
            timestamp={dt}
            pressure={pressure}
            temp={temp}
            visibility={visibility}
            humidity={humidity}
            clouds={clouds}
          ></WeatherInfoDisplay>
        </div>
      </div>
    </>
  );
}

export default DashBoard;
